import React, { useState, useEffect } from 'react';
import { CardGiftcard } from '@mui/icons-material';
import { consoleLogInDev, formatCurrency } from 'shared';
import { Colors } from 'library';
import { Card, Chip, Icon, Row, Stack, Text, Title } from 'library/ui';
import { IBusinessUserDiscount } from 'models/Discount';
import { listForBusiness } from 'api/DiscountApi';
import { formatMonthDayYear } from 'shared/Dates';

const LocationDiscounts = () => {
    const [discounts, setDiscounts] = useState<IBusinessUserDiscount[]>([]);

    useEffect(() => {
        getProviderOrCenerLocationOptions();
    }, []);

    const getProviderOrCenerLocationOptions = () => {
        listForBusiness()
            .then((response) => {
                setDiscounts(response.results.sort((a, b) => (a?.address?.id || 0) - (b?.address?.id || 0)));
            })
            .catch((error) => {
                consoleLogInDev(error);
            });
    };

    if (!discounts.length) {
        return <></>;
    }

    const totalAvailable = discounts.reduce((sum, discount) => sum + discount.value, 0);

    return (
        <Card padding="lg">
            <Stack gap="md">
                <Row justify="between" align="center">
                    <Title size="h2">Credits</Title>
                    <Chip variant="filled" bgColor={Colors.secondarySoft} textColor={Colors.secondary}>
                        {formatCurrency(totalAvailable)} available
                    </Chip>
                </Row>
                <Stack gap="sm">
                    {discounts.map((discount, i) => (
                        <Card key={i} padding="sm" tone="muted">
                            <Row gap="sm" align="start">
                                <Icon
                                    icon={CardGiftcard}
                                    size="md"
                                    bgColor={Colors.secondarySoft}
                                    iconColor={Colors.secondary}
                                />
                                <Stack gap="none" grow>
                                    <Row justify="between" align="center" gap="md">
                                        <Text weight="bold">{formatCurrency(discount.value)}</Text>
                                        {discount.expires_at && (
                                            <Text size="sm" tone="secondary">
                                                Expires {formatMonthDayYear(discount.expires_at)}
                                            </Text>
                                        )}
                                    </Row>
                                    <Text>
                                        {discount.address?.description} — {discount.address?.street}{' '}
                                        {discount.address?.city} {discount.address?.state}
                                    </Text>
                                    <Text size="sm" tone="secondary">
                                        Added {formatMonthDayYear(discount.added_at)}
                                    </Text>
                                </Stack>
                            </Row>
                        </Card>
                    ))}
                </Stack>
            </Stack>
        </Card>
    );
};

export default LocationDiscounts;
